import { f7 } from 'framework7-react';
import { fetchMAffiliateSettingsApi } from '@/api/infoApi';
import { isIPhone } from '@/config/device';
import { store } from '@/config/store';
import { themeId as THEME_ID } from '@/consts/shop';

// 移行案内を出す対象ブランドの themeId（プラウド）
const MIGRATION_TARGET_THEME_IDS: number[] = [THEME_ID.PROUD];

// 標準版「マイくる」のストアURL取得元の加盟店ID
const STANDARD_AFFILIATE_ID = 1;

// path_type=2: ネイティブが onShouldStartLoadWithRequest で横取りし外部で開く
// （2025-04〜本番稼働・実機検証済みの経路）
const openExternal = (url: string) => {
  const sep = url.includes('?') ? '&' : '?';
  window.open(`${url}${sep}path_type=2`, '_blank');
};

/** ブランドアプリ内ログイン時にアプリ移行を促す */
export const maybeShowMigrationPrompt = async () => {
  // URL ?theme= で明示的にブランドアプリとしてアクセスした場合のみ対象。
  // affiliate 由来で themeId が設定されるケースを除外するため globalTheme を参照。
  const globalTheme = store.state.globalTheme as number | null;
  console.log(
    '[migrationPrompt] globalTheme:',
    globalTheme,
    'targets:',
    MIGRATION_TARGET_THEME_IDS,
  );
  if (!globalTheme || !MIGRATION_TARGET_THEME_IDS.includes(globalTheme)) return;

  // 標準版「マイくる」(m_affiliate_id=1) のストアURLを取得
  // 取得失敗時はストア検索URLにフォールバック
  const fallbackUrl = isIPhone
    ? 'https://apps.apple.com/jp/search?term=マイくる'
    : 'https://play.google.com/store/search?q=マイくる';
  let storeUrl = '';
  try {
    const res = await fetchMAffiliateSettingsApi({
      m_affiliate_id: STANDARD_AFFILIATE_ID,
    });
    const settings = res?.data?.data;
    storeUrl = (isIPhone ? settings?.ios_url : settings?.android_url) ?? '';
  } catch (e) {
    console.error(e);
  }
  if (!storeUrl) storeUrl = fallbackUrl;

  const showDialog = () => {
    f7.dialog
      .create({
        title: 'アプリ移行のお願い',
        text: 'このアプリは提供終了を予定しています。今後は「マイくる」アプリをご利用ください。同じID・パスワードで、これまでのご契約・車両情報をそのままご確認いただけます。',
        closeByBackdropClick: false,
        buttons: [
          {
            text: 'アプリを入手',
            bold: true,
            onClick: () => {
              openExternal(storeUrl);
              // ボタン押下でダイアログが自動で閉じるため、再度表示する
              setTimeout(showDialog, 500);
            },
          },
        ],
      })
      .open();
  };

  showDialog();
};
